import './ShareModal.css'; 
import React, { useState } from 'react';
import { FaFacebook, FaSms, FaLink, FaInstagram, FaFacebookMessenger, FaTiktok} from 'react-icons/fa';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons';;


const ShareModal = ({ isOpen, onClose, videoOneURL, videoTwoURL }) => {
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [showCopiedMessage, setShowCopiedMessage] = useState(false);
    const defaultPrompt = "Check out this video I saw on GenAITok";

    const handleClose = () => {
        setSelectedVideo(null); 
        onClose();
    };


    const handleChange = (url) => {
        setSelectedVideo(url);
        var elements = document.getElementsByClassName("icon-button");
        for(var i = 0; i < elements.length; i++) {
            elements[i].style.pointerEvents = 'auto';
        }
    }
    
    if (!isOpen) return null;

    const socialMediaShareUrls = (url) => ({
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(defaultPrompt)}`,
        x: `https://x.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(defaultPrompt)}`,
        instagram: `https://www.instagram.com/direct/new/?text=${encodeURIComponent(defaultPrompt + ' ' + url)}`,
        messenger: `https://www.messenger.com/`, 
        tiktok: `https://www.tiktok.com/messages?lang=en/` 
    });

    const handleShareClick = (platform) => {
        console.log(selectedVideo);
        if (!selectedVideo) return;
        const urls = socialMediaShareUrls(selectedVideo);
        window.open(urls[platform], '_blank', 'noopener,noreferrer');
    };

    const handleMessagesShare = (url) => {
        if (!selectedVideo) return;
        const smsUrl = `sms:?&body=${encodeURIComponent(defaultPrompt)}%20${encodeURIComponent(selectedVideo)}`;
        window.open(smsUrl, '_blank');
    };

    
    const handleLinkCopy = () => {
        navigator.clipboard.writeText(selectedVideo).then(() => {
            setShowCopiedMessage(true);
            alert('Video link has been copied!');
            setTimeout(() => setShowCopiedMessage(false), 2000);
        }).catch(() => {
            alert('Failed to copy the link. Please copy it manually.');
        });
    };

    const handleInstagramShare = () => {
        if (!selectedVideo) return;
    
        // Copy the link to clipboard
        navigator.clipboard.writeText(selectedVideo).then(() => {
            setShowCopiedMessage(true);
            alert('Link copied to clipboard for Instagram sharing!'); // Show alert before opening the new window
    
            // Open the Instagram sharing link after showing the alert
            const instagramUrl = socialMediaShareUrls(selectedVideo).instagram;
            window.open(instagramUrl, '_blank', 'noopener,noreferrer');
    
            setTimeout(() => setShowCopiedMessage(false), 2000);
        }).catch(() => {
            alert('Failed to copy the link. Please copy it manually.');
        });
    };

    const handleTikTokShare = () => {
        if (!selectedVideo) return;
    
        // Copy the link to clipboard
        navigator.clipboard.writeText(selectedVideo).then(() => {
            setShowCopiedMessage(true);
            alert('Link copied to clipboard for Tiktok sharing!'); // Show alert before opening the new window
    
            // Open the Instagram sharing link after showing the alert
            const tikTokUrl = socialMediaShareUrls(selectedVideo).tiktok;
            window.open(tikTokUrl, '_blank', 'noopener,noreferrer');
    
            setTimeout(() => setShowCopiedMessage(false), 2000);
        }).catch(() => {
            alert('Failed to copy the link. Please copy it manually.');
        });
    };

    const handleMessengerShare = () => {
        if (!selectedVideo) return;
    
        // Copy the link to clipboard
        navigator.clipboard.writeText(selectedVideo).then(() => {
            setShowCopiedMessage(true);
            alert('Link copied to clipboard for Messenger sharing!'); // Show alert before opening the new window
    
            // Open the Messenger sharing link after showing the alert
            const instagramUrl = socialMediaShareUrls(selectedVideo).messenger;
            window.open(instagramUrl, '_blank', 'noopener,noreferrer');
    
            setTimeout(() => setShowCopiedMessage(false), 2000);
        }).catch(() => {
            alert('Failed to copy the link. Please copy it manually.');
        });
    };

    return (
        <div className="share-modal-overlay">
            <div className="share-modal">
                <button className="close-button" onClick={handleClose}>×</button>
                <div className="social-media-container">
                    <div className="social-media-icons">
                        <button onClick={() => handleShareClick('facebook')} className="icon-button">
                            <FaFacebook className="icon" />
                        </button>
                        <button onClick={handleMessagesShare} className="icon-button">
                            <FaSms className="icon" />
                        </button>
                        <button onClick={() => handleShareClick('x')} className="icon-button">
                            <FontAwesomeIcon icon={faXTwitter} className="icon" />
                        </button>
                        <button onClick={handleLinkCopy} className="icon-button">
                            <FaLink className="icon" />
                        </button>
                        <button onClick={handleInstagramShare} className="icon-button">
                            <FaInstagram className="icon" />
                        </button>
                        <button onClick={handleMessengerShare} className="icon-button">
                            <FaFacebookMessenger className="icon" />
                        </button>
                        <button onClick={handleTikTokShare} className="icon-button">
                            <FaTiktok className="icon" />
                        </button>
                    </div>
                </div>
                <div className="button-container">
                    <label>
                        <input type="radio" name="video" value={videoOneURL} onChange={() => handleChange(videoOneURL)} />
                        Top
                    </label>
                    <label>
                        <input type="radio" name="video" value={videoTwoURL} onChange={() => handleChange(videoTwoURL)} />
                        Bottom
                    </label>
                </div>
            </div>
        </div>
    );
};

export default ShareModal;
